const PRODUCT_FORMAT_OPTIONS = [
  { value: 'detalle', label: 'Detalle' },
  { value: 'mayorista', label: 'Mayorista' },
];
const CLIENT_TYPE_OPTIONS = PRODUCT_FORMAT_OPTIONS;

const normalizeProductFormatCode = (value) => {
  if (value == null) return '';
  const normalized = String(value).trim().toLowerCase();
  return normalized === 'importador' ? 'mayorista' : normalized;
};
const normalizeClientType = normalizeProductFormatCode;

const resolvePriceProductFormatCode = (price) => {
  const normalized = normalizeProductFormatCode(
    price?.productFormatCode || price?.productFormat?.code || price?.ProductFormat?.code || price?.clientType
  );
  if (normalized) return normalized;
  return 'mayorista';
};
const resolvePriceClientType = resolvePriceProductFormatCode;

const getProductFormatLabel = (value, formats = PRODUCT_FORMAT_OPTIONS) => {
  const normalized = normalizeProductFormatCode(value);
  const option = (Array.isArray(formats) ? formats : PRODUCT_FORMAT_OPTIONS)
    .find((item) => item.value === normalized || item.code === normalized);
  return option ? option.label : normalized || 'Mayorista';
};
const getClientTypeLabel = getProductFormatLabel;

const buildProductFormatOptions = (formats) => {
  const source = Array.isArray(formats) ? formats : [];
  const options = [];
  const seen = new Set();
  source.forEach((format) => {
    const code = normalizeProductFormatCode(format?.code || format?.value);
    if (!code || seen.has(code)) return;
    options.push({
      value: code,
      label: String(format?.name || format?.label || code).trim() || code,
    });
    seen.add(code);
  });
  return options.length ? options : PRODUCT_FORMAT_OPTIONS;
};

export {
  PRODUCT_FORMAT_OPTIONS,
  CLIENT_TYPE_OPTIONS,
  normalizeProductFormatCode,
  normalizeClientType,
  resolvePriceProductFormatCode,
  resolvePriceClientType,
  getProductFormatLabel,
  getClientTypeLabel,
  buildProductFormatOptions,
};
